import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/TiktokBudgetAllocation.graphql';
import { Query, QuerytiktokBudgetAllocationArgs } from '../../__generated__/globalTypes';

export const useTiktokBudgetAllocationQuery = (options?: QueryHookOptions<Query, QuerytiktokBudgetAllocationArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerytiktokBudgetAllocationArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useTiktokBudgetAllocationLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerytiktokBudgetAllocationArgs>
): QueryResult<Query, QuerytiktokBudgetAllocationArgs> & {
  getTiktokBudgetAllocation: LazyQueryExecFunction<Query, QuerytiktokBudgetAllocationArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getTiktokBudgetAllocation, result] = useLazyQuery<Query, QuerytiktokBudgetAllocationArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getTiktokBudgetAllocation, ...result };
};

export const useTiktokBudgetAllocationPromiseQuery = () => {
  const client = useApolloClient();

  const getTiktokBudgetAllocation = useCallback(
    (options?: Omit<QueryOptions<QuerytiktokBudgetAllocationArgs, Query>, 'query'>) =>
      client.query<Query, QuerytiktokBudgetAllocationArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getTiktokBudgetAllocation };
};
// Suspense Query Hooks
export const useTiktokBudgetAllocationSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerytiktokBudgetAllocationArgs>
) => {
  const result = useSuspenseQuery<Query, QuerytiktokBudgetAllocationArgs>(QUERY, {
    ...options
  });

  return result;
};
